<template>

  <SweetTable ref="table" :selection="true" url="/trade/factorystorelog/page" :query-form="queryForm"
              delete-url="/store">
    <el-table-column
        prop="agreementCode"
        label="合同编号"
        min-width="160"
        fixed="left"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column prop="productCode" label="品番号" min-width="90" v-if="productType==='产品'"
                     header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="skuCode" label="SKU" min-width="90" v-if="productType==='产品'" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="productName" label="品名" min-width="90" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="color" label="颜色" min-width="90" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="size" label="规格" min-width="90" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="attr1" label="幅宽" min-width="90" v-if="productType==='原料'" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="attr2" label="克重" min-width="90" v-if="productType==='原料'" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="nameZh" label="中文品名" min-width="120" v-if="productType==='产品'" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="reason" label="变动原因" min-width="100" header-align="center"
                     align="center"></el-table-column>
    <el-table-column prop="count" label="数量" min-width="90" header-align="center"
                     align="center">
      <template #default="{row}">
        <div style="color:#67C23A;" v-if="row.type === 1">
          {{ row.count }}
        </div>
        <div style="color:#F56C6C;" v-else-if="row.type === -1">
          {{ row.count }}
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="operateTime" label="出入库日期" width="100" header-align="center"
                     align="center"></el-table-column>
    <el-table-column label="图片" min-width="90">
      <template #default="{row}">
        <img-viewer v-if="row.imgs" :imgs="row.imgs"></img-viewer>
      </template>
    </el-table-column>
    <el-table-column prop="updaterName" label="制单人" min-width="100" header-align="center"
                     align="center"></el-table-column>
    <el-table-column label="制单时间" prop="updateDate" width="160" header-align="center"
                     align="center">
    </el-table-column>
    <el-table-column label="备注" prop="remark" width="160" header-align="center"
                     align="center">
    </el-table-column>
  </SweetTable>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
export default {
  components: {  },
  mixins:[SweetTable],
  props: {
    productType: '',
  },
  data () {
    return {
      queryForm: {
        productCode: '',
        productType: '',
        productName: '',
        orderCode: '',
        storeType: '',
        color: '',
        size: '',
        attr1: '',
        attr2: ''
      }
    }
  },
  watch: {
    productType: {
      handler: function (newVal) {
        this.queryForm.productType = newVal
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.reload()
          }
        })
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
  },
}
</script>

<style scoped></style>
